export default {
  perView: 3,
  type: 'carousel',
  gap: 20,
  focusAt: 1,
  breakpoints: {
    400: {
      perView: 1
    },
    800: {
      perView: 2
    },
    1024: {
      perView: 3
    },
    1100: {
      perView: 2
    }
  }
};
